import logger from "@next/core-logger"
import {AxiosRequestConfig} from "axios"
import {IncomingHttpHeaders} from "http"
import axios from "../../utils/axios"
import ProductsApi from "../../config/api/products"
import build from "../../utils/buildProductsRequestParams"
import {SearchApiRequestTypes, TOKEN_CANCELLATION_FLAG} from "../../config/constants"
import {ExternalSearchApiResponse} from "../../models/searchApi"
import {BloomreachCookiesInitialVal} from "../../models/SearchState"
import {httpUrlTrimmer} from "../../utils/httpUrlTrimmer"
import {devboxUrlTrimmer} from "../../utils/devboxUrlTrimmer"

interface GetProductsFragmentByPageFnOptions {
    headers: IncomingHttpHeaders
    url: string
    baseUrl: string
    searchTerm: string | null
    type: SearchApiRequestTypes
    pageSize: number
    fields: (keyof ExternalSearchApiResponse)[]
    bloomreachCookiesInitialVal: BloomreachCookiesInitialVal
    bloomreachPersonalizationEnabled: boolean
    pageLoadTrigger: string
    cancelToken?: AxiosRequestConfig["cancelToken"]
    sliceSize: number
    start: number
    productSummaryTemplateName?: string
    imageRatio?: string
    bloomreachDefaultProviderArgs: string
}

export const getProductsFragmentByPage = async ({
    url,
    baseUrl,
    headers,
    searchTerm,
    type,
    start,
    pageSize,
    fields,
    bloomreachCookiesInitialVal,
    bloomreachPersonalizationEnabled,
    cancelToken,
    pageLoadTrigger,
    sliceSize,
    productSummaryTemplateName = "",
    imageRatio = "",
    bloomreachDefaultProviderArgs,
}: GetProductsFragmentByPageFnOptions): Promise<string> => {
    try {
        const getProductsFragmentApi = ProductsApi("getProductsFragment")
        const urlParam = devboxUrlTrimmer(httpUrlTrimmer(url))

        const response = await axios({
            method: getProductsFragmentApi.method,
            url: `${baseUrl}${getProductsFragmentApi.localEndpoint()}`,
            headers: headers as {
                [header: string]: string
            },
            params: build({
                url: urlParam,
                searchTerm,
                type,
                pageSize,
                bloomreachCookiesInitialVal,
                bloomreachPersonalizationEnabled,
                pageLoadTrigger,
                sliceSize,
                fields,
                start,
                productSummaryTemplateName,
                imageRatio,
                bloomreachDefaultProviderArgs,
            }),
            cancelToken,
        })
        return response.data as string
    } catch (error) {
        const err = error as Error
        if (err.message !== TOKEN_CANCELLATION_FLAG) {
            logger.error(error, "getProductsFragmentByPage")
        }

        throw error
    }
}
